import { Typography } from 'fuse-ui';
import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import SelectMulti from 'pre-fuse/components/SelectMulti';

import PropTypes from 'prop-types';

const styles = theme => ( {
    label: {
        paddingRight: theme.spacing.unit,
    },
} );

const DomainManagementOrgDomainMultiSelect = ( { classes, orgDomainSelectData, handleOrgDomainMultiSelectFilter } ) => {
    const [selectedDomainOptions, setSelectedDomainOptions] = useState( [] );

    const changeHandler = ( newSelection ) => {
        setSelectedDomainOptions( newSelection );
        handleOrgDomainMultiSelectFilter( newSelection.map( ( row ) => row.value ) );
    };

    return (
        <>
            <Typography className={classes.label}>Subdomains of:</Typography>
            <SelectMulti
                id="domain-management-org-domain-multi-select"
                options={orgDomainSelectData}
                placeholder={'Select parent domains'}
                searchPlaceholder={'Type in to Search'}
                value={selectedDomainOptions}
                onChange={changeHandler}
            />
        </>
    );
};

DomainManagementOrgDomainMultiSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    handleOrgDomainMultiSelectFilter: PropTypes.func.isRequired,
    orgDomainSelectData: PropTypes.array.isRequired,
};

export default withStyles( styles )( DomainManagementOrgDomainMultiSelect );
